import React from "react";
import EditIcon from "../../icons/editIcon";
import TrashIcon from "../../icons/trashIcon";
import styles from "./style.module.css";

const CarCard = ({ car, activeCar, handleCarClick, handleOpenEditCarModal, handleOpenDeleteCarModal }) => {
  return (
    <div className={styles.car_card_wrapper}>
      <div
        className={`${styles.car_card} ${
          activeCar && activeCar._id === car._id ? styles.car_card_active : ""
        }`}
        onClick={() => handleCarClick(car)}
      >
        <div className={styles.car_card_inner}>
          <div className={styles.car_card_name}>{car.name}</div>
          <div className={styles.car_card_empty}></div>
        </div>
      </div>
      <div className={styles.car_card_actions}>
        <button type="button" onClick={() => handleOpenEditCarModal(car)}>
          <EditIcon />
        </button>
        <button type="button" onClick={() => handleOpenDeleteCarModal(car)}>
          <TrashIcon />
        </button>
      </div>
    </div>
  );
};

export default CarCard;
